<div class="alert alert-info noPrint">
  @if (this.layout.mode === 'zebra') {
    <i class="fas fa-print"></i>
    Labels print at <strong>{{ this.layout.widthMm }} &times; {{ this.layout.heightMm }} mm</strong>, one per label.
    In the print dialog choose the Zebra printer, set <strong>Margins: None</strong> and <strong>Scale: 100</strong>,
    and make sure the printer's label stock is set to the same size.
  } @else {
    <i class="fas fa-print"></i>
    Labels print as an <strong>A4 sheet</strong>.
  }
  The label size is set under Settings &rsaquo; Company Settings.
</div>
